import { SVGProps } from '@components/Icon/types';

export const PlusCircle = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      d="M5.96667 9.99999C5.96667 9.61339 6.28008 9.29999 6.66667 9.29999H9.30005V6.66667C9.30005 6.28008 9.61345 5.96667 10 5.96667C10.3866 5.96667 10.7 6.28008 10.7 6.66667V9.29999H13.3333C13.7199 9.29999 14.0333 9.61339 14.0333 9.99999C14.0333 10.3866 13.7199 10.7 13.3333 10.7H10.7V13.3333C10.7 13.7199 10.3866 14.0333 10 14.0333C9.61345 14.0333 9.30005 13.7199 9.30005 13.3333V10.7H6.66667C6.28008 10.7 5.96667 10.3866 5.96667 9.99999Z"
      fill={fill}
    />
    <path
      d="M0.966675 10C0.966675 5.03008 5.03008 0.966675 10 0.966675C14.9699 0.966675 19.0333 5.03008 19.0333 10C19.0333 14.9699 14.9699 19.0333 10 19.0333C5.03008 19.0333 0.966675 14.9699 0.966675 10ZM10 2.36667C5.80327 2.36667 2.36667 5.80327 2.36667 10C2.36667 14.1967 5.80327 17.6333 10 17.6333C14.1967 17.6333 17.6333 14.1967 17.6333 10C17.6333 5.80327 14.1967 2.36667 10 2.36667Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'plus-circle';
